module.exports = require('./src/node');



//////////////////
// WEBPACK FOOTER
// ./~/debug/node.js
// module id = 2558
// module chunks = 0